import headerScrollWhite from '../partials/headerWhite'
import Swiper from 'swiper'

export default {
  init() {
    window.onscroll = headerScrollWhite;

    // Intro Slider
    // eslint-disable-next-line
    let introSlider = new Swiper ('.career-slider', {
      slidesPerView: 1.1,
      spaceBetween: 10,
      breakpoints: {
        575: {
          slidesPerView: 2.1,
          spaceBetween: 20,
        },
        992: {
          simulateTouch: false,
          slidesPerView: 3,
          spaceBetween: 35,
        },
      },
    });
  },

  // JavaScript to be fired on all pages, after page specific JS is fired
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/careerPage.js